import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { ModalableWhiteboardDrawing } from '../../../../../../models/modalable-whiteboard-drawing';
import { ApplicationStateService } from '../../../../../../services/application-state.service';
import {
    WhiteboardDrawingBoardComponent,
    WhiteboardDrawingCanvasService,
    WhiteboardEventsService,
    WhiteboardRecordingService
} from '@lemberger/whiteboards';
import screenfull from 'screenfull';
import { WhiteboardDrawing } from '../../../../../../models/whiteboard-drawing';
import { environment } from '../../../../../../../environments/environment';
import { RouteService } from '../../../../../../services/route.service';
import { ModalComponent } from '../../../../../../models/modal-component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-whiteboard-drawing-modal',
    templateUrl: './whiteboard-drawing-modal.component.html',
    styleUrls: ['./whiteboard-drawing-modal.component.scss'],
    imports: [
        WhiteboardDrawingBoardComponent,
        NgClass
    ],
    encapsulation: ViewEncapsulation.None
})
export class WhiteboardDrawingModalComponent extends ModalComponent implements OnChanges, OnInit, AfterViewInit {
    @Input() declare modalable: ModalableWhiteboardDrawing;
    @ViewChild('modal') modal: ElementRef;

    whiteboardDrawing: WhiteboardDrawing;
    protected readonly environment = environment;
    protected readonly window = window;

    constructor(public applicationStateService: ApplicationStateService,
                public whiteboardDrawingCanvasService: WhiteboardDrawingCanvasService,
                public whiteboardDrawingEventsService: WhiteboardEventsService,
                private whiteboardRecordingService: WhiteboardRecordingService,
                public routeService: RouteService,
                private eventService: WhiteboardEventsService) {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.castWhiteboard();
    }

    ngOnInit(): void {
        this.castWhiteboard();
    }

    ngAfterViewInit(): void {
        $(this.modal.nativeElement).on('hide.bs.modal', (e) => {
            // If the video is being saved don't do anything
            if (this.whiteboardDrawingEventsService.loading.getValue()) {
                e.preventDefault();
            }
            // If there's no recording in the service or the video has already been saved don't ask for confirmation
            if (
                (this.whiteboardRecordingService.blob === '' || this.whiteboardDrawing.video) &&
                !this.whiteboardRecordingService.isRecording &&
                !this.whiteboardRecordingService.isPaused) {
                this.clearModal();
            } else {
                if (confirm('Möchten Sie die Aufzeichnung wirklich verwerfen?')) {
                    this.clearModal();
                } else {
                    e.preventDefault();
                }
            }
        });
    }

    isFullscreen(): boolean {
        return (screenfull as any).isFullscreen;
    }

    getId(): string {
        return this.modalable.getModalId();
    }

    private clearModal(): void {
        this.whiteboardRecordingService.blob = '';
        if (this.whiteboardRecordingService.mediaRecorder &&
            (this.whiteboardRecordingService.mediaRecorder.state !== 'inactive')) {
            this.whiteboardRecordingService.stop();
        }
        this.whiteboardRecordingService.stopTimer();
        this.whiteboardDrawingCanvasService.toggleVideoMode(false);
        this.eventService.videoError(false);
        this.eventService.emitEnableSave(false);
    }

    private castWhiteboard(): void {
        this.whiteboardDrawing = this.modalable.asWhiteboardDrawing();
    }
}
